module.exports = __webpack_public_path__ + "img/应用.917fbf8e.png";